import * as Sentry from "@sentry/capacitor";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getConversations } from "@/Services/TherapyApi/Agent";
import ConversationTransformer from "@/Modules/Transformers/Agent/Conversations";

import useAppStore from "@/Modules/App/Store";
import useAgentStore from "@/Modules/Agent/Store";

import { danger } from "@/Utils/Debug";

async function fetchConversationsAH() {
  const agentStore = useAgentStore();
  const appStore = useAppStore();

  agentStore.isLoadingData = true;

  try {
    const conversationsApi = await getConversations();
    const conversationDomain = conversationsApi.map(ConversationTransformer.toDomain);

    agentStore.conversations = conversationDomain;

    return true;
  } catch (e) {
    danger(e);
    Sentry.captureException(e);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });

    return false;
  } finally {
    agentStore.isLoadingData = false;
  }
}

export default fetchConversationsAH;
